/**
 * 视频文件信息（codec/bitrate 等）懒加载：请求 /api/music/:id/media-info 并写回 metadata
 * 抽离自 MusicPlayer.js
 */

/**
 * @param {object|null} currentMusic
 * @param {function(function(object): object): void} setContextCurrentMusic - React setState 风格
 * @param {function(object): string|null} getVideoFilePath
 * @param {React.MutableRefObject<Set<unknown>>} ensuredMediaInfoRef - 已请求过的 id 集合，用于去重
 * @returns {Promise<void>}
 */
export async function ensureVideoMediaInfo(currentMusic, setContextCurrentMusic, getVideoFilePath, ensuredMediaInfoRef) {
  try {
    const m = currentMusic;
    const id = m?.id;
    if (!id) return;

    const meta = (() => {
      try {
        const raw = m?.metadata;
        return typeof raw === 'string' ? JSON.parse(raw) : (raw || {});
      } catch (_) {
        return {};
      }
    })();

    if (!getVideoFilePath(m)) return;
    if (meta.video_codec || meta.audio_codec || meta.video_bitrate || meta.audio_bitrate) return;

    if (ensuredMediaInfoRef.current.has(id)) return;
    ensuredMediaInfoRef.current.add(id);

    const resp = await fetch(`/api/music/${id}/media-info`, { cache: 'no-store' });
    const json = await resp.json().catch(() => null);
    if (!json?.success || !json?.data?.metadata) {
      ensuredMediaInfoRef.current.delete(id);
      return;
    }
    const newMeta = json.data.metadata;

    setContextCurrentMusic((prev) => {
      if (!prev || prev.id !== id) return prev;
      return { ...prev, metadata: newMeta };
    });
  } catch (_) {
    try {
      const id = currentMusic?.id;
      if (id) ensuredMediaInfoRef.current.delete(id);
    } catch (_) {}
  }
}
